import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'components/Select';

import Button from 'components/Button';
import './style.css';

const Dropdown = ({
  placeholder,
  options,
  onChange,
  onApply,
  className,
  isDisabled,
  testId,
  ...rest
}) => {
  const [option, selectOption] = useState(null);

  const _onChange = (_option) => {
    if (onApply) {
      selectOption(_option);
    }
    if (onChange) {
      onChange(_option);
    }
  };

  return (
    <div
      className={`flex lg:justify-start justify-between ${className}`}
      data-testid={testId}
    >
      <Select
        {...rest}
        options={options}
        isSearchable={false}
        onChange={_onChange}
        components={{ IndicatorSeparator: () => null }}
        placeholder={placeholder}
        isDisabled={isDisabled}
        className="dropdown-select"
      />
      {!!onApply && (
        <Button
          title="Apply"
          className="ml-4 lg:ml-2 bg-gray-50 px-4 w-auto py-0 border border-javelin-gray-border box-border text-javelin-blueGray text-sm hover:bg-gray-100 disabled:bg-gray-50 rounded"
          onClick={() => onApply(option)}
          isDisabled={isDisabled}
        />
      )}
    </div>
  );
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  onApply: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  testId: PropTypes.string,
};
Dropdown.defaultProps = {
  options: [],
  placeholder: 'Select action',
  className: '',
  isDisabled: false,
  testId: 'dropdown',
};

export default memo(Dropdown);
